import React, {useEffect, useLayoutEffect, useState} from 'react';
import s from './Templates.module.css'
import {Formik} from 'formik';
import plus from '../../../assets/img/personalAccount/whitePlus.svg'
import Table, {ColumnsType} from "antd/es/table";
import Icon from '@ant-design/icons';
import {ReactComponent as Trash} from '../../../assets/img/personalAccount/trash.svg';
import {ReactComponent as Edit} from '../../../assets/img/personalAccount/edit.svg';
import {ConfirmModal} from "./ConfirmModal/ConfirmModal";
import {useNavigate} from "react-router-dom";
import {useAppDispatch, useAppSelector} from "../../../hooks/redux";
import {ITemplate} from "../../../types/interfaces";
import MyInput from "../../../components/ui/MyInput/MyInput";
import MyBtn from '../../../components/ui/MyBtn/MyBtn';
import TransparentButton from "../../../components/ui/TransparentButton/TransparentButton";
import CustomDropdownForAccounts from "../../../components/ui/CustomDropdownForAccounts/CustomDropdownForAccounts";
import CustomDropdown from "../../../components/ui/CustomDropdown/CustomDropdown";
import {getTemplateListThunk} from "../../../store/reducers/ActionCreators";
import {useSelector} from "react-redux";
import {selectTemplatesByFilter} from "../../../store/reducers/TransactionsSlice/selector";
import {setFiltersTemplates, setTransferDataPreview} from "../../../store/reducers/TransactionsSlice/TransactionsSlice";
import {useAccountsForSelect} from "../../../hooks/useAccountsForSelect";
import {motion} from "framer-motion";
import CustomModal from "../../../components/ui/CustomModal/CustomModal";
import styles from "../../../styles/styles.module.css"

interface DataType {
    name: JSX.Element | string,
    recipient: string,
    type: string,
    action: JSX.Element | string,

}

const columns: ColumnsType<DataType> = [
    {
        title: 'Account Number',
        dataIndex: 'accountNumber',
    },
    {
        title: 'Name',
        dataIndex: 'name',
    },
    {
        title: 'Recipient',
        dataIndex: 'recipient',
    },
    {
        title: 'Type',
        dataIndex: 'type',
        className: `${s.typeColumn}`
    },
    {
        title: 'Action',
        dataIndex: 'action',
        className: `${s.actionColumn}`
    },
];
const Templates = () => {
    const navigate = useNavigate()
    const dispatch = useAppDispatch()
    const accountsList = useAccountsForSelect()
    const token = useAppSelector(state => state.userReducer.userToken)
    const accountId = useAppSelector(state => state.userReducer.chosenAccountTypeId)
    const selectedTemplatesList = useSelector(selectTemplatesByFilter)
    const initTemplatesList = useAppSelector(state => state.transactionsReducer.templates)
    const userAccountStatus = useAppSelector(state => state.userReducer.user.userData.userAccountStatusLabel)

    useEffect(() => {
        sessionStorage.removeItem("template-form");
        sessionStorage.removeItem("template-internal-form");
        dispatch(setTransferDataPreview({}))

        return () => {
            sessionStorage.removeItem("template-form");
            sessionStorage.removeItem("template-internal-form");
            dispatch(setTransferDataPreview({}))
        }
    }, [])

    const templatesNames: string[] = []

    const newTemplatesNames = () => {
        initTemplatesList?.map((template: ITemplate) => templatesNames.push(template.templateName))
    }
    newTemplatesNames()

    templatesNames.push("ALL")

    useEffect(() => {
        dispatch(getTemplateListThunk(token, accountId))

        return () => {
            dispatch(setFiltersTemplates({
                accountNumber: 'ALL',
                templateName: '',
                recipient: '',
                hiddenAccountNumber: '',
            }))
        }
    }, [])

    const [showConfirmModal, setShowConfirmModal] = useState<boolean | null>(false)
    const [isTemplateSuccessfullyDeleted, setIsTemplateSuccessfullyDeleted] = useState<boolean | null>(null)
    const [TemplateForDelete, setTemplateForDelete] = useState({
        name: '',
        id: null! as number
    })
    const [isMobile, setIsMobile] = React.useState(false)
    const [hiddenAccountNumber, setHhiddenAccountNumber] = React.useState('')

    const deletePaymentTemplate = (id: number, name: string) => {
        setTemplateForDelete({
            ...TemplateForDelete,
            id: id,
            name: name
        })
        setShowConfirmModal(true)
    }

    const editPaymentTemplate = (id: number) => {
        navigate(`edit-template/${id}`)
    }

    const tableData = selectedTemplatesList?.map((item: ITemplate) => {
        return {
            key: item.id,
            accountNumber: item.fromAccountMainIban,
            name: <div onClick={() => {
                handleNavigate(item.id, item.paymentType
                    ? (item.paymentType === 'sepa' ? item.paymentType.toUpperCase() : item.paymentType)
                    : item.type)
            }} className={s.linkDiv}>{item.templateName}</div>,
            recipient: item.recipientDetails?.companyName
                ? item.recipientDetails.companyName
                : `${item.toAccountUserName
                    ? item.toAccountUserName
                    : (item.recipientDetails.beneficiaryName || `${item.recipientDetails.firstName} ${item.recipientDetails.lastName}`)}`,
            type: <span className={s.capitalize}>
                {
                    item.paymentType
                        ? (item.paymentType === 'sepa' ? item.paymentType.toUpperCase() : item.paymentType)
                        : item.type}
            </span>,
            action: <div className={s.actions_wrapper}>
                <div className={s.actionBlock} onClick={() => editPaymentTemplate(item.id)}>
                    <Icon className={s.editIcon} component={() => <Edit/>} rev={undefined}/>
                    <p className={s.editText}>Edit</p>
                </div>
                <div className={s.actionBlock} onClick={() => deletePaymentTemplate(item.id, item.templateName)}>
                    <Icon className={s.deleteIcon} component={() => <Trash/>} rev={undefined}/>
                    <p className={s.deleteText}>Delete</p>
                </div>
            </div>
        }
    })

    const handleNavigate = (param?: string | number, templateType?: string | number) => {
        if (param === 'create') {
            navigate(`new-template/${param}/${templateType}`)
        } else {
            navigate(`pay-by/${param}/${templateType}`)
        }

    }

    const getStatusOfDeletedTemplate = (res: any) => {
        if (res.data === "Deleted") {
            setIsTemplateSuccessfullyDeleted(true)
        } else {
            setIsTemplateSuccessfullyDeleted(false)
        }
    }

    useEffect(() => {
        if (window.innerWidth <= 500) {
            setIsMobile(true)
        } else {
            setIsMobile(false)
        }
     }, [window.innerWidth])

    if (userAccountStatus === 'Suspended') {
        return (
            <div>
                <CustomModal type={"error"} isNotify isModalOpen={true}>
                    <div className={styles.modal_content}>
                        <div className={styles.popup_subtitle}>
                            <span className={styles.error}>Failed!</span> You’re temporarily unable to make transfers
                            because your account has been suspended. Please try again later or contact support.
                        </div>
                        <div className={styles.popup_button_block}>
                            <MyBtn buttonType={"error"} isPersonalAccountBtn title={"Ok"}
                                   onClick={() => navigate('/personal-account/accounts')}/>
                        </div>
                    </div>
                </CustomModal>
            </div>
        )
    }

    return (
        <motion.div
            initial={{opacity: 0, scale: 1}}
            animate={{opacity: 1, scale: 1}}
            transition={{duration: 0.5}}
        >
            <ConfirmModal setShowModal={setShowConfirmModal} showModal={showConfirmModal}
                          TemplateForDelete={TemplateForDelete}
                          getStatusOfDeletedTemplate={getStatusOfDeletedTemplate}
            />

            <CustomModal type="confirm" isNotify isModalOpen={isTemplateSuccessfullyDeleted} setIsModalOpen={setIsTemplateSuccessfullyDeleted}>
                <div className={styles.modal_content}>
                    <div className={styles.popup_subtitle}>
                        <span className={styles.success}>Success!</span> Your template has been deleted successfully.
                    </div>
                    <div className={styles.popup_button_block}>
                        <MyBtn isPersonalAccountBtn title={"Ok"} onClick={() => {setIsTemplateSuccessfullyDeleted(null)}}/>
                    </div>
                </div>
            </CustomModal>

            <CustomModal type="error" isNotify isModalOpen={isTemplateSuccessfullyDeleted === false} setIsModalOpen={setIsTemplateSuccessfullyDeleted}>
                <div className={styles.modal_content}>
                    <div className={styles.popup_subtitle}>
                        <span className={styles.error}>Failed!</span> Something went wrong. Please try again or contact us.
                    </div>
                    <div className={styles.popup_button_block}>
                        <MyBtn buttonType="error" isPersonalAccountBtn title={"Ok"} onClick={() => {setIsTemplateSuccessfullyDeleted(null)}}/>
                    </div>
                </div>
            </CustomModal>

            <div className={s.formTemplatesWrapper}>
                <h2 className={s.transfersWrapperTitle}>List of Templates</h2>

                <Formik
                    initialValues={{
                        accountNumber: '',
                        templateName: '',
                        recipient: '',
                    }}
                    onSubmit={(values) => {
                        const tempData = {...values, hiddenAccountNumber: hiddenAccountNumber}
                        dispatch(setFiltersTemplates(tempData))
                    }}
                >
                    {({
                        values,
                        handleChange,
                        handleSubmit
                      }) => (
                        <form className={s.form} onSubmit={handleSubmit}>
                            <div className={s.accountInfoRow}>
                                <div className={s.dropdown_wrapper}>
                                    <p className={s.labelText}>Account Number</p>
                                    <CustomDropdownForAccounts
                                        items={accountsList}
                                        id={'accountNumber'}
                                        name={'accountNumber'}
                                        setAccountNumber={setHhiddenAccountNumber}
                                    />
                                </div>

                                <div className={s.dropdown_wrapper}>
                                    <p className={s.labelText}>Template name</p>
                                    <CustomDropdown
                                        items={templatesNames}
                                        id={'templateName'}
                                        name={'templateName'}
                                    />
                                </div>
                            </div>

                            <div className={s.inputsWrapper}>
                                <div className={s.inputWrapper}>
                                    <p className={s.labelText}>Recipient</p>
                                    <MyInput
                                        name={'recipient'}
                                        id={'recipient'}
                                        value={values.recipient}
                                        onChange={handleChange}
                                    />
                                </div>
                                <div className={s.buttonWrapper}>
                                    <TransparentButton
                                        large
                                        isPersonalAccountBtn
                                        type={'submit'}
                                        title={'Show'}/>
                                </div>
                            </div>
                        </form>)}
                </Formik>
            </div>
            <div className={s.transfersWrapper}>
                <Table
                    bordered={false}
                    className={s.transfersTable}
                    columns={columns}
                    dataSource={tableData}
                    pagination={false}
                />

                {
                    selectedTemplatesList.map((template: ITemplate) =>
                        <div key={template.id} className={s.templateMobile}>
                            <div className={s.templateItemWrapper}>
                                <p className={s.templateLabel}>Account number</p>
                                <div className={s.templateValueWrapper}>
                                    <div className={s.templateValue}>
                                        {template.fromAccountMainIban}
                                    </div>
                                </div>
                            </div>

                            <div className={s.templateItemWrapper}>
                                <p className={s.templateLabel}>Recipient</p>
                                <div className={s.templateValueWrapper}>
                                    <div className={s.templateValue}>
                                        {template.toAccount ? template.toAccount : template.recipient}
                                    </div>
                                </div>
                            </div>

                            <div className={s.flex}>
                                <div className={s.templateItemWrapper}>
                                    <p className={s.templateLabel}>Name</p>
                                    <div className={s.templateValueWrapper}>
                                        <div onClick={() => {handleNavigate(template.id, template.type)}} className={s.linkDiv}>
                                            {template.templateName}
                                        </div>
                                    </div>
                                </div>

                                <div className={s.templateItemWrapper}>
                                    <p className={s.templateLabel}>Type</p>
                                    <div className={s.templateValueWrapper}>
                                        <div className={s.templateValue}>
                                            {template.type}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div>
                                <p className={s.templateLabel}>Action</p>
                                <div className={s.actionBlock} onClick={() => deletePaymentTemplate(template.id, template.templateName)}>
                                    <Icon className={s.deleteIcon} component={() => <Trash/>} rev={undefined}/> <p>Delete</p>
                                </div>
                            </div>

                        </div>)
                }

                <div className={s.tableButtonWrapper}>
                    <MyBtn medium icon={plus} style={{ width: isMobile ? '100%' : 180 }}
                           isPersonalAccountBtn
                           title={'New template'}
                           onClick={() => {
                               handleNavigate('create', 'new')
                           }}/>
                </div>
            </div>
        </motion.div>
    );
};

export default Templates;


